function formatFileSize(bytes){
    let mbBytes =  bytes/(1024*1024);
    return `${mbBytes.toPrecision(2)}MB`;
}

const demoSelections = {
    "R020_Size": "M",
    "R030_Design": "NFD02",
    "R031_PAINT_BAC": "6",
    "R032_PAINT_C2": "1",
    "R033_PAINT_C3": "8",
    "R039_PAINT_FINISH": "GLOSSY",
    "R040_Groupset": "SHIULTR8070",
    "R240 Crank": "ROTADU5236A",
    "R220 Cranklengte": "172",
    "R230 Cassette": "1130",
    "R130 Dreambuilder wheels": "FORZALEVANTO",
    "R260 Outer Tires": "VITRUP25",
    "R120 Type of Kit": "4ZAAER0001",
    "R200 Stuurbreedte": "40",
    "R210 Stuurpenlengte": "100",
    "R250 Saddle": "SEISLRLADY",
    "C2D_Background": "background_0001",
    "price": {
        "currency": "EUR",
        "msrp": 7823,
        "price": 7823,
        "from": false
    }
};
const demoFavorite = 'M3GGF1GTAX';// (This does not match the demo Selections)

async function generate(ev) {
    let outEl = document.getElementById('output');
    //const ref = `https://f2cgd69ovj.execute-api.eu-west-1.amazonaws.com/dev/image?model=NOAHFAST_DISC&selections=%7B%22R020_Size%22%3A%22M%22%2C%22R030_Design%22%3A%22NFD02%22%2C%22R031_PAINT_BAC%22%3A%226%22%2C%22R032_PAINT_C2%22%3A%221%22%2C%22R033_PAINT_C3%22%3A%228%22%2C%22R039_PAINT_FINISH%22%3A%22GLOSSY%22%2C%22R040_Groupset%22%3A%22SHIULTR8070%22%2C%22R240%20Crank%22%3A%22ROTADU5236A%22%2C%22R220%20Cranklengte%22%3A%22172%22%2C%22R230%20Cassette%22%3A%221130%22%2C%22R130%20Dreambuilder%20wheels%22%3A%22FORZALEVANTO%22%2C%22R260%20Outer%20Tires%22%3A%22VITRUP25%22%2C%22R120%20Type%20of%20Kit%22%3A%224ZAAER0001%22%2C%22R200%20Stuurbreedte%22%3A%2240%22%2C%22R210%20Stuurpenlengte%22%3A%22100%22%2C%22R250%20Saddle%22%3A%22SEISLRLADY%22%2C%22C2D_Background%22%3A%22background_0001%22%2C%22price%22%3A%7B%22currency%22%3A%22EUR%22%2C%22msrp%22%3A7823%2C%22price%22%3A7823%2C%22from%22%3Afalse%7D%7D`

    const scale = document.getElementById('scale').value;
    const format = document.getElementById('format').value;
    const force = document.getElementById('force').checked;
    const locale = document.getElementById('locale').value;
    const model = "NOAHFAST_DISC";

    const baseArgs = [ // Only used for image generation (not pdf)
        ...(scale? [ ['scale', scale] ] : []),
        ...(force? [ ['force', force] ] : []),
    ];

    const favoriteCode = document.getElementById('favoriteCode').value;

    const baseApi = `/api/customize`;
    let fetchCall = null;
    let url = null;
    if(format === 'both') {
        url = new URL(`${baseApi}/${model}`, window.location.href);
        let body = [];

        // With background
        body.push(Object.fromEntries([
            ...baseArgs,
            ['format', 'jpg'],
            favoriteCode? ['favorite', favoriteCode] : ['selections', demoSelections],
        ]));

        // Without background
        body.push(Object.fromEntries([
            ...baseArgs,
            ['format', 'png'],
            ...(favoriteCode
                ? [['favorite', favoriteCode], ['background', 'NONE']]
                : [['selections', { ...demoSelections, 'C2D_Background': 'NONE' }]]),
        ]));

        fetchCall = fetch(url.href, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    }else if(['jpg','png'].includes(format)){
        url = new URL(`${baseApi}/${model}`, window.location.href);
        let args = [
            ...baseArgs,
            ...(format? [ ['format', format] ] : []),
            favoriteCode? ['favorite', favoriteCode] : ['selections', JSON.stringify(demoSelections)],
        ];

        for (let [key,value] of args){
            url.searchParams.set(key, value);
        }

        fetchCall = fetch(url.href);
    }else if(format==='pdf'){
        url = new URL(`${baseApi}/pdf/${favoriteCode||demoFavorite}` + (locale? `/${locale}`:''), window.location.href);
        url.searchParams.set('force', force||false);

        fetchCall = fetch(url.href);
    }else{
        window.alert("Unrecognized format option")
    }


    // Indicate working
    outEl.innerHTML = '! GENERATING, PLEASE WAIT!';
    outEl.classList.add('generating');
    outEl.classList.remove('result-success');
    outEl.classList.remove('result-error');

    try {
        let response = await fetchCall;
        if (response.status >= 200 && response.status < 300) {
            let result = await response.json();
            let results = result instanceof Array? result : [result]

            /** @type {HTMLTemplateElement} */
            let template = document.createElement('template');
            let html = '';

            for(let result of results){
                let timings = [];
                for (let key in result.timings) {
                    let ms = result.timings[ key ];
                    timings.push(`<span class="timing">
                    <span class="task">${key}</span>
                    <span class="duration">
                        ${Math.floor(ms / 1000)}s&nbsp;
                        ${("000" + (Math.ceil(ms % 1000)).toString()).slice(-3)}ms
                    </span>
                    <span class="spacer"></span>
                </span>`);
                }
                html += `
                    <div class="results">
                        <div style="margin: 0 auto;">Filesize: <b>${formatFileSize(result.filesize)}</b></div>
                        ${format === 'pdf'
                            ? `<a href=${result.noCacheUrl || result.result}>Download</a>`
                            : `<img style="max-width: 75%;object-fit: contain;margin: 0 auto;" src="${result.noCacheUrl || result.result}"/>`
                        }
                        <div style="font-size: 0.8rem; color: #000;margin: 0 auto;">
                            <strong>URL</strong><br/>
                            <a href="${result.result}">${result.result}</a>
                        </div>
                    </div>
                    <div class="timings">
                        ${timings.join('\n')}
                        <span class="timing">
                            <span class="task"><b>TOTAL</b></span>
                            <span class="duration"><b>
                                ${Math.floor(result.duration / 1000)}s&nbsp;
                                ${("000" + (Math.ceil(result.duration % 1000)).toString()).slice(-3)}ms
                            </b></span>
                            <span class="spacer"></span>
                        </span>
                    </div>
                    <div style="height: 3rem; width: 1rem;"></div>
                `;
            }
            template.innerHTML = html;

            outEl.innerHTML = '';
            outEl.appendChild(template.content.cloneNode(true));

            outEl.classList.add('result-success');
            outEl.classList.remove('generating');
            outEl.classList.remove('result-error');
        } else {
            outEl.innerText = `${response.status} - ${response.statusText}`;
            outEl.classList.remove('result-success');
            outEl.classList.remove('generating');
            outEl.classList.add('result-error');
        }
    } catch (err) {
        outEl.innerText = `${err.toString()}`;
        outEl.classList.remove('result-success');
        outEl.classList.remove('generating');
        outEl.classList.add('result-error');
    }
}

// Debug info
async function gpuInfo(ev) {
    let outEl = document.getElementById('output');

    let url = new URL(`/api/info/gpu`, window.location.href);

    // Indicate working
    outEl.innerHTML = '! FETCHING GPU-INFO, PLEASE WAIT!';
    outEl.classList.add('generating');
    outEl.classList.remove('result-success');
    outEl.classList.remove('result-error');

    try {
        let response = await fetch(url.href);
        if (response.status >= 200 && response.status < 300) {
            let result = await response.json();

            /** @type {HTMLTemplateElement} */
            let template = document.createElement('template');
            let timings = [];
            for (let key in result.timings) {
                let ms = result.timings[ key ];
                timings.push(`<span class="timing">
                    <span class="task">${key}</span>
                    <span class="duration">
                        ${Math.floor(ms / 1000)}s&nbsp;
                        ${("000" + (Math.ceil(ms % 1000)).toString()).slice(-3)}ms
                    </span>
                    <span class="spacer"></span>
                </span>`);
            }
            template.innerHTML = `
                <div class="results" style="font-size: 85%">
                    ${result.result.style}
                    ${result.result.info}
                </div>
                <div class="timings">
                    ${timings.join('\n')}
                    <span class="timing">
                        <span class="task"><b>TOTAL</b></span>
                        <span class="duration"><b>
                            ${Math.floor(result.duration / 1000)}s&nbsp;
                            ${("000" + (Math.ceil(result.duration % 1000)).toString()).slice(-3)}ms
                        </b></span>
                        <span class="spacer"></span>
                    </span>
                </div>
            `;

            outEl.innerHTML = '';
            outEl.appendChild(template.content.cloneNode(true));

            // outEl.classList.add('result-success');
            outEl.classList.remove('generating');
            outEl.classList.remove('result-error');
        } else {
            outEl.innerText = `${response.status} - ${response.statusText}`;
            outEl.classList.remove('result-success');
            outEl.classList.remove('generating');
            outEl.classList.add('result-error');
        }
    } catch (err) {
        outEl.innerText = `${err.toString()}`;
        outEl.classList.remove('result-success');
        outEl.classList.remove('generating');
        outEl.classList.add('result-error');
    }
}

function updateForm(){
    const format = document.getElementById('format').value;
    let localeField = document.getElementById('locale-field');
    if(format==='pdf'){
        localeField.style.display = 'block';
    }else{
        localeField.style.display = 'none';
    }
}

function bindEvents() {
    let generateBtn = document.getElementById('generate');
    generateBtn.addEventListener('click', () => generate());

    let gpuInfoButton = document.getElementById('gpu-info');
    gpuInfoButton.addEventListener('click', () => gpuInfo());

    let formatInput = document.getElementById('format');

    formatInput.addEventListener('change', updateForm);
    updateForm();
}
bindEvents();
